import {
    RESET_PASSWORD_USER,
    RESETED_PASSWORD_USER,
    SEND_AUTHENTICATION_CODE,
    SENT_AUTHENTICATION_CODE,
    REQUEST_USER_CODES,
    LOADED_USER_CODES,
} from '../actions/users.action'

const initialStates = {
    loading: false,
    fetching_codes: false,
    sending_code: false,
    data: []
};

export default function users(state = initialStates, action) {
    const { payload, type } = action;
    switch (type) {
        case RESET_PASSWORD_USER:
            return { ...state, loading: true };
        case RESETED_PASSWORD_USER:
            return { ...state, data: {'token': payload}, loading: false };
        case SEND_AUTHENTICATION_CODE:
            return { ...state, code: "", sending_code: true };
        case SENT_AUTHENTICATION_CODE:
            return { ...state, code: payload, sending_code: false };
        case REQUEST_USER_CODES:
            return { ...state, codes: [], fetching_codes: true };
        case LOADED_USER_CODES:
            return { ...state, codes: payload, fetching_codes: false };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/users.reducer.js